import { addDays } from "date-fns";
import { parse, stringify } from "query-string";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { map } from "rxjs";

import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../common/searchParams.utils";
import { ConfirmationModalThird } from "../ConfirmationModal/ConfirmationModalThird";
import { AdminPaymentValidationParams } from "./AdminPaymentValidation.interface";
import AdminPaymentValidationSearch from "./AdminPaymentValidationSearch";
import { ContentMessageConfirmation } from "./AdminPaymentValidationStyles";
import AdminPaymentValidationTable from "./AdminPaymentValidationTable";

const AdminPaymentValidationResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: AdminPaymentValidationParams) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const from_date = getDateAttribute(params.from_date);
      const to_date = getDateAttribute(params.to_date, addDays(new Date(), 5));
      const payment_status_option = getAttributeList(
        params.payment_status_option
      );
      const cashback_status_option = getAttributeList(
        params.cashback_status_option
      );
      const differential_status_option = getAttributeList(
        params.differential_status_option
      );
      const bank_type = getAttributeList(params.bank_type);
      return {
        ...params,
        volante_nums,
        from_date,
        to_date,
        payment_status_option,
        cashback_status_option,
        differential_status_option,
        bank_type,
      };
    })
  );

  const [showPaymentConfirmation, updateShowPaymentConfirmation] =
    useState(false);
  const [titleConfirmation, updateTitleConfirmation] = useState("");
  const [messageConfirmation, updateMessageConfirmation] = useState("");
  const togglePaymentConfirmation = () => {
    updateShowPaymentConfirmation(!showPaymentConfirmation);
  };
  const onTitleConfirmationChange = (title: string) => {
    updateTitleConfirmation(title);
  };
  const onMessageConfirmationChange = (message: string) => {
    updateMessageConfirmation(message);
  };
  const history = useHistory();

  const [showLabelPaymentNum, setShowLabelPaymentNum] = useState("");
  return (
    <div>
      <AdminPaymentValidationSearch params$={params$} />
      <AdminPaymentValidationTable
        params$={params$}
        onMessageConfirmationChange={onMessageConfirmationChange}
        setShowLabelPaymentNum={setShowLabelPaymentNum}
        onTitleConfirmationChange={onTitleConfirmationChange}
        togglePaymentConfirmation={togglePaymentConfirmation}
      />
      {showPaymentConfirmation && (
        <ConfirmationModalThird
          onAccept={() => {
            updateShowPaymentConfirmation(!showPaymentConfirmation);
            const parsedParams = { ...parse(window.location.search), page: 1 };
            const stringifiedParams = stringify(parsedParams);
            const pathname = history.location.pathname;
            history.push(`${pathname}?${stringifiedParams}`);
          }}
          title={titleConfirmation}
          toggleModal={() => {
            updateShowPaymentConfirmation(!showPaymentConfirmation);
            const parsedParams = { ...parse(window.location.search), page: 1 };
            const stringifiedParams = stringify(parsedParams);
            const pathname = history.location.pathname;
            history.push(`${pathname}?${stringifiedParams}`);
          }}
          buttonTitle={"Entendido"}
          backgroundColor={"#002E6C"}
        >
          <ContentMessageConfirmation>
            <p>
              {messageConfirmation} <strong>{showLabelPaymentNum}</strong>
            </p>
          </ContentMessageConfirmation>
        </ConfirmationModalThird>
      )}
    </div>
  );
};

export default AdminPaymentValidationResource;
